import { createContext, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';
const defaultProps = {
  horizontalSpacing: {
    sm: 3,
    md: 6,
    lg: 11
  },
  spacingVerticalAround: {
    sm: 4,
    md: 7
  },
  spacingBetweenSections: {
    sm: 7,
    md: 9,
    lg: 15
  },
  anchorsPosition: -90
};
const SectionSpacingContext = /*#__PURE__*/createContext(defaultProps);
function SectionSpacingProvider({
  children,
  horizontalSpacing = defaultProps.horizontalSpacing,
  spacingVerticalAround = defaultProps.spacingVerticalAround,
  spacingBetweenSections = defaultProps.spacingBetweenSections,
  anchorsPosition = defaultProps.anchorsPosition
}) {
  return /*#__PURE__*/jsx(SectionSpacingContext.Provider, {
    value: {
      horizontalSpacing,
      spacingVerticalAround,
      spacingBetweenSections,
      anchorsPosition
    },
    children: children
  });
}
const useSectionSpacingContext = () => useContext(SectionSpacingContext);
export { SectionSpacingProvider, useSectionSpacingContext };
//# sourceMappingURL=SectionSpacingProvider.js.map
